export const staticRoutesList = [];
